import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, Box, IconButton, Popover, Typography } from '@mui/material';
import { useLocalizedContents } from '@ps-smart-cp/ppfw-client';
import { useState } from 'react';
import { globalAreaButtonFont } from '../styles';
import type { Notification } from './NotificationList';
import { NotificationList } from './NotificationList';

interface NotificationButtonProps {
  notifications: Notification[];
}

function NotificationButton({ notifications }: NotificationButtonProps) {
  const { msg } = useLocalizedContents();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <IconButton
        id="notification-panel"
        disableTouchRipple
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{ ...globalAreaButtonFont, borderRadius: '0%', marginTop: '2px' }}
      >
        <Badge color="error" variant="dot" invisible={notifications.length === 0}>
          <NotificationsIcon sx={{ fontSize: '18px' }} />
        </Badge>
      </IconButton>

      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Box sx={{ width: 320, maxHeight: 400, overflow: 'auto' }}>
          {notifications.length === 0 ? (
            <Typography sx={{ fontSize: '12px', padding: '8px 16px' }}>{msg.ico13026}</Typography>
          ) : (
            <NotificationList notifications={notifications} />
          )}
        </Box>
      </Popover>
    </>
  );
}

export type { NotificationButtonProps };
export { NotificationButton };
